import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { PostHogProvider } from 'posthog-js/react';
import { queryClient } from './lib/queryClient';
import { posthogConfig } from './lib/posthog';
import App from './App';

const { apiKey, options } = posthogConfig;

function AppWithProviders() {
  return (
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </StrictMode>
  );
}

// Only wrap with PostHogProvider if API key is configured
createRoot(document.getElementById('root')!).render(
  apiKey ? (
    <PostHogProvider apiKey={apiKey} options={options}>
      <AppWithProviders />
    </PostHogProvider>
  ) : (
    <AppWithProviders />
  )
);
